import consentEn from './locales/components/consent.en.json';
import consentEs from './locales/components/consent.es.json';

import homeEn from './locales/pages/home.en.json';
import homeEs from './locales/pages/home.es.json';
import privacyEn from './locales/pages/privacy.en.json';
import privacyEs from './locales/pages/privacy.es.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import prelaunchEn from './locales/pages/prelaunch.en.json';
import prelaunchEs from './locales/pages/prelaunch.es.json';
import aboutEn from './locales/pages/about.en.json';
import aboutEs from './locales/pages/about.es.json';
import profileEn from './locales/pages/profile.en.json';
import profileEs from './locales/pages/profile.es.json';

const resources = {
  en: {
    'pages/about': aboutEn,
    'pages/home': homeEn,
    'pages/profile': profileEn,
    'pages/privacy': privacyEn,
    prelaunch: prelaunchEn,
    'components/consent': consentEn,
  },
  es: {
    'pages/about': aboutEs,
    'pages/home': homeEs,
    'pages/profile': profileEs,
    'pages/privacy': privacyEs,
    prelaunch: prelaunchEs,
    'components/consent': consentEs,
  },
};


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    ns: ['pages/about', 'pages/home', 'pages/profile', 'pages/privacy', 'prelaunch', 'components/consent'],
    defaultNS: 'pages/home',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'cookie', 'querystring', 'sessionStorage', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

export default i18n;
